import { render, hydrate } from 'react-dom';

import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import './index.css';
import './lib/initAmplify';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './lib/amplify';
import { cgtag } from 'utilities/gtag';

import { createBrowserHistory, History } from 'history';
import { BrowserRouter } from 'react-router-dom';
import { IS_DEV, IS_SNAP } from 'environment';
export const history: History<BrowserRouter> = createBrowserHistory();

if (!IS_DEV && !IS_SNAP) {
  // Init Sentry...
  Sentry.init({
    dsn: 'https://c8011f78b603430e9ecca3b7732ab33d@o1059355.ingest.sentry.io/6047848',
    release: process.env.REACT_APP_VERSION || 'unknown',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],
    tracesSampleRate: 0.2,
  });
}

if (!IS_SNAP) {
  // Init TAG Manager
  (function (w: any, d: any, s: any, l: any, i: any) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-PS9PV3N');

  // Init Klaviyo
  var klaviyoScript = document.createElement('script');
  klaviyoScript.src = '//static.klaviyo.com/onsite/js/klaviyo.js?company_id=PZiXMr';
  klaviyoScript.setAttribute('type', 'text/javascript');
  klaviyoScript.async = true;
  document.head.appendChild(klaviyoScript);
}

// React-Snap hydration support...
const rootElement = document.getElementById('root');
if (rootElement && rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}

// @ts-ignore
const sendToAnalytics = ({ id, name, value }) => {
  const eventData = {
    action: name,
    value: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
    label: id, // id unique to current page load
    nonInteraction: true, // avoids affecting bounce rate
  };
  cgtag('web_vitals', eventData);
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToAnalytics);
